import { TranslatorService } from '@app/core/services/translator/translator.service'
import { saveAction } from './../../../../payment-order/edit-revenue-expenses-trades/store/payment-order-edit-revenue-expenses-trades.actions'
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper'
import { Component, Inject, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatHorizontalStepper } from '@angular/material/stepper'
import { CaceisApiErrors } from '@app/core/services/exception/caceis-exceptions/caceis-api-errors/caceis-api-errors'
import { CaceisErrors } from '@app/core/services/exception/caceis-exceptions/caceis-general-errors/caceis-errors'
import { FeatureService } from '@app/core/services/feature/feature.service'
import { ConfirmBoxColor } from '@app/custom-shared/components/alerts/confirm-box/confirm-box.component'
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service'
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base'
import { MasterClienteHomeCreateProfileService } from './service/master-cliente-home-create-profile.service'
import {
  CreateProfileRequest,
  MasterClienteViewPermissionsCreateProfileService,
} from './views/permissoes/master-cliente-create-profile.service'
import { MasterClienteCreateProfileComponent } from './views/permissoes/master-cliente-create-profile.component'

@Component({
  selector: 'app-master-cliente-home-create-profile',
  templateUrl: './master-cliente-home-create-profile.component.html',
  styleUrls: ['./master-cliente-home-create-profile.component.scss'],
  providers: [
    MasterClienteHomeCreateProfileService,
    MasterClienteViewPermissionsCreateProfileService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class MasterClienteHomeCreateProfileComponent extends AppScreenBase
  implements OnInit {
  constructor(
    private serviceHomeCreateProfile: MasterClienteHomeCreateProfileService,
    private serviceViewCreateProfile: MasterClienteViewPermissionsCreateProfileService,
    public dialogRef: MatDialogRef<MasterClienteHomeCreateProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private warningService: DialogBoxService,
    private featureService: FeatureService,
    private translatorService: TranslatorService
  ) {
    super()
    if (this.data && this.data.from == 'MasterClientePerfilAcesso')
      this.startedByMasterClientePerfilAcesso = true
  }

  startedByMasterClientePerfilAcesso: boolean = false
  isEditable = false
  firstFormGroup: any
  usersSelected: Array<string>
  rolesSelected: Array<string>
  form: FormGroup
  
    @ViewChild(MasterClienteCreateProfileComponent) masterClienteCreateProfileComponent!: MasterClienteCreateProfileComponent;
  
  @ViewChild('stepper', { static: false }) stepper: MatHorizontalStepper

  ngOnInit() {}
  onClose(): void {}

  closeWindow() {
    let title, message, cancel, save: string
    title = this.translatorService.translateConfirmBox('titleConfirm')
    message = this.translatorService.translateConfirmBox('subtitleConfirm')
    cancel = this.translatorService.translateConfirmBox('cancelConfirm')
    save = this.translatorService.translateConfirmBox('saveProfile')
    this.appDialog.confirmBox({
      lblTitle: title,
      lblSubtitle: message,
      lblCancelButton: cancel,
      lblConfirmButton: save,
      color: ConfirmBoxColor.error,
      onConfirm: () => {
        this.dialogRef.close()
      },
    })
  }

  //async checkIfPermissionNameExists(name) {
  //this.serviceViewCreateProfile.checkPermissionName({ name });
  //}

  async saveProfile(event) {
    let warnPerm : string

    this.featureService.translatorService.
    getMessage('Selecione ao menos 1 relatório')
    .subscribe(
      data=>warnPerm=data
    )
    const isValid = this.masterClienteCreateProfileComponent.validateCheckedItems();
    if (!isValid) {
      warnPerm.showWarn();
      return;
    }
    event.preventDefault()
    event.stopPropagation()

    const name: string = this.serviceHomeCreateProfile.form.get('name').value
    if (name == undefined || name.trim() == '') {
      this.serviceHomeCreateProfile.form.get('name').markAsTouched()
      return
    }

    const rolesSelected = this.serviceHomeCreateProfile.getRolesSelected()

    if (rolesSelected.length == 0) {
      this.warningService.snackbarUtil.showWarn(
        'É preciso escolher uma permissão'
      )
      return
    }

    // Verifica se nome ja existe
    const result = await this.serviceViewCreateProfile
      .checkPermissionName({ name })
      .toPromise()

    if (result == null) {
      // CaceisApiErrors.GENERIC_ERROR.showError()
      return
    }

    if (result && result.exists == true) {
      this.serviceHomeCreateProfile
        .getMessageProfileNameDuplicated(name)
        .showWarn()
      return
    }

    const description = this.serviceHomeCreateProfile.form.get('description')
      .value

    const permissionList = rolesSelected.map(permission => {
      return { id: permission }
    })

    const profile: CreateProfileRequest = {
      profile: name,
      permissions: permissionList,
      description: description || '',
    }

    const {
      exists,
      profiles: profilesExists,
    } = await this.serviceViewCreateProfile.checkPermissions(profile)

    if (exists) {
      this.confimDuplicateProfile(profilesExists, profile)
      return
    }

    return this.createProfile(profile)
  }

  createProfile(profile) {
    let title, message, cancel, save: string
    title = this.translatorService.translateConfirmBox('titleCreateProfile')
    message = ''
    cancel = this.translatorService.translateConfirmBox('cancelConfirm')
    save = this.translatorService.translateConfirmBox('saveProfile')

    return this.appDialog.confirmBox({
      lblTitle: title,
      lblSubtitle: message,
      lblCancelButton: cancel,
      lblConfirmButton: save,
      color: ConfirmBoxColor.error,
      onConfirm: async () => {
        const { id } = await this.serviceViewCreateProfile.createProfile(
          profile
        )
        this.dialogRef.close(id)
      },
    })
  }

  confimDuplicateProfile(profilesExists, profile) {
    let title, message, cancel, save: string
    title = this.translatorService.translateConfirmBox('titleCreateProfile')
    cancel = this.translatorService.translateConfirmBox('cancelConfirm')
    save = this.translatorService.translateConfirmBox('okSaveProfile')
    message = this.tratentListOfProfiles(profilesExists)
    return this.appDialog.confirmBox({
      lblTitle: title,
      lblSubtitle: message,
      lblCancelButton: cancel,
      lblConfirmButton: save,
      color: 'red',
      onConfirm: async () => {
        profile.forceTrue = true
        const { id } = await this.serviceViewCreateProfile.createProfile(
          profile
        )
        this.dialogRef.close(id)
      },
    })
  }

  tratentListOfProfiles(profiles: Array<{ id: string; name: string }>) {
    let msg1, msg2, msg3: string
    msg1 = this.translatorService.translateConfirmBox('mesageCreateProfile1')
    msg2 = this.translatorService.translateConfirmBox('mesageCreateProfile2')
    msg3 = this.translatorService.translateConfirmBox('mesageCreateProfile3')

    if (profiles.length > 1) {
      return msg1 + `(${profiles.map(a => `${a.name}`).join(', ')}` + msg2
    }

    return msg3 + `(${profiles.map(a => `${a.name}`).join(', ')}` + msg2
  }
}
